<template>
  <router-view />
</template>

<script>
import Splash from './core/Utils/splash-screen'

export default {
  name: 'App',
  mounted() {
    Splash.hide()
  },
}
</script>
